import React, { useEffect, useState, Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { useLanguage } from '../../includes/LanguageContext.js'; // Importing Language Context
import config from "../../includes/ConfigFile";

const Trending = ({ company }) => {
    const { currentLanguage, selectedLanguage, setSelectedLanguage } = useLanguage(); // Get current language from LanguageContext.js file
const settings = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 4,
    swipeToSlide: true,
    // style: {
    //     background: "#222", // Specify the background color here
    //     color: '#bada55',
    // },
    afterChange: function (index) {
        console.log(
            `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
        );
    },
    responsive: [
        {
            breakpoint: 1024, // screen width <= 1024px
            settings: {
                slidesToShow: 3,
                centerPadding: "40px",
            },
        },
        {
            breakpoint: 600, // screen width <= 600px
            settings: {
                slidesToShow: 1,
                centerPadding: "20px",
            },
        },
    ],
};
const slidesData = [
    {
        image: `${config.BASE_URL}/public/uploads/admin/post/1757266373_3c06a86572a6029faa5e.jpeg`,
        title: "Karwat",
        content1: "37 घंटे",
        content2: "This is the second piece of content for slide 1.",
        customLink: '63'
    },
    {
        image: `${config.BASE_URL}/public/uploads/admin/post/1757266818_ee48a77553fc38b8643e.jpeg`,
        title: "Chorbazari",
        content1: "37 घंटे",
        content2: "This is the second piece of content for slide 2.",
        customLink: '65'
    },
    {
        image: `${config.BASE_URL}/public/uploads/admin/post/1757266621_1ff84d7a5dad303cc622.jpeg`,
        title: "Ek Din Achanak",
        content1: "37 घंटे",
        content2: "This is the second piece of content for slide 3.",
        customLink: '64'
    },
    {
        image: `${config.BASE_URL}/public/uploads/admin/post/1757266072_7bbb58608c600d17dee8.jpeg`,
        title: "Ishqe Safar",
        content1: "37 घंटे",
        content2: "This is the second piece of content for slide 4.",
        customLink: '62'
    },
    
];
//Show Category List

return (
    <>
        <section>
                    <div className="tw-mt-4 md:tw-mt-10">
                        <div className="tw-flex tw-flex-row">
                            <div className="row align-items-start">
                                <div className="col-md-10">
                                    <a href="#" className="heading-title">
                                        <h2 className="">
                                            {currentLanguage.homeHeading.trending}
                                        </h2>
                                    </a>
                                </div>
                                <div class="col-md-2 d-flex justify-content-end">
                                    <a href="#" className="">
                                        <i className="bi bi-chevron-right"></i>
                                    </a>
                                </div>

                            </div>
                            <div className="slider-container">
                                <Slider {...settings}>
                                    {slidesData.map((slide, index) => (
                                        <Link to={`/story/${slide.customLink}`} key={index} className="slide-link">
                                            <div key={index} className="slide">
                                                <img src={slide.image} alt={`Slide ${index + 1}`} />
                                                <div className="slide-content">
                                                    <div  className="title text-light text-center">
                                                        {slide.title}
                                                    </div>

                                                    {/* <p>{slide.content1}</p> */}
                                                    {/* <p>{slide.content2}</p> */}
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
    </>
);

};
export default Trending;